import React from 'react'
import ContactMessageEdit from '../../components/admin/contact-messages/contact-message-edit'
import AdminTemplate from '../../templates/admin-template'

const AdminContactMessageEditPage = () => {
  return (
    <AdminTemplate>
        <ContactMessageEdit/>
    </AdminTemplate>
  )
}

export default AdminContactMessageEditPage